var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E9DFFFB5-1E47-46BA-B328-EC94D61F983D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PQ--Contact",
    transform: "translate(-417.000000, -216.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(417.000000, 216.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.861253,0.5 C13.717965,0.5 16.308158,1.66216042 18.1842518,3.53825422 C20.0603456,5.41434803 21.222506,8.00454097 21.222506,10.861253 C21.222506,13.717965 20.0603456,16.308158 18.1842518,18.1842518 C16.308158,20.0603456 13.717965,21.222506 10.861253,21.222506 C8.00454097,21.222506 5.41434803,20.0603456 3.53825422,18.1842518 C1.66216042,16.308158 0.5,13.717965 0.5,10.861253 C0.5,8.00454097 1.66216042,5.41434803 3.53825422,3.53825422 C5.41434803,1.66216042 8.00454097,0.5 10.861253,0.5 Z",
    id: "Path",
    stroke: "#FFFFFF",
    fill: "#3BB724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3661264,8.55960076 L10.4828924,14.442669 C10.3063904,14.619171 10.0747005,14.708002 9.84301054,14.708002 C9.61132058,14.708002 9.37963066,14.619171 9.20312868,14.442669 L6.26159458,11.5011349 C5.90759622,11.1473023 5.90759622,10.5752037 6.26159458,10.2213712 C6.61542718,9.86737279 7.18735993,9.86737279 7.54135829,10.2213712 L9.84301054,12.5230234 L15.0863626,7.27983705 C15.4401952,6.92583869 16.012128,6.92583869 16.3661264,7.27983705 C16.719959,7.63366965 16.719959,8.2056024 16.3661264,8.55960076 Z",
    id: "Path",
    fill: "#FAFAFA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0b799f11dd226040d8f2e57918c589b9.svg";
export { ForwardRef as ReactComponent };